import "react-responsive-modal/styles.css";

import React, { useEffect, useState } from 'react'
import Modal from "react-responsive-modal";
import RadioGroup from "./RadioGroup";
import Loader from "../../../components/Loader";

const ModalBox = ({ title, options, selectedValue, open, setModal, setValue, setNote, note, onChanged, isLoading }) => {
    const textAreaHandler = (e) => {
        setNote(e.target.value);
    }

    return (
        <div className="modalBox">
            <Modal
                open={open}
                onClose={() => setModal(false)}
                center
                closeIcon={<img src="/assets/images/close-icon.svg" loading='Lazy'
                    className='border-white focus:!border-0 focus:!outline-none !outline-none !border-0 m-3 ' 
                    alt="close" />}
                className="p-4 z-[100] w-fit"
            >
                <div className="modal p-[5px]">
                    <h1 className="text-[#1F1F1F] text-lg font-medium mb-[10px]">
                        {title}
                    </h1>
                    <RadioGroup options={options} selectedValue={selectedValue} setValue={setValue}/>

                    <div>
                        <textarea onChange={textAreaHandler} className="h-[120px] w-[350px] border-[#DDDDDD] border resize-none 
                    rounded p-4 my-6 py-3 text-sm font-semibold placeholder:text-[#1F1F1F] 
                    scrollBar" value={note} placeholder='Note' />
                    </div>

                    <div className="flex justify-end gap-2">
                        <button className="text-[#9E2064] py-[10px] px-4" onClick={() => setModal(false)}>Cancel</button>
                        <button className="bg-[#9E2064] py-[10px] px-4 text-[#FFFFFF] rounded-xl w-[81px] h-[44px]" 
                            data-testid="change-btn"
                            onClick={onChanged}
                        >
                            {isLoading ? <Loader /> : 'Change'}
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ModalBox